<template>
  <div class="config-container">
    <!-- Botón hamburguesa visible solo en mobile -->
    <button class="btn btn-outline-primary d-md-none m-3" @click="menuAbierto = !menuAbierto">
      <font-awesome-icon :icon="['fas', 'bars']" />
      Menú
    </button>

    <div class="d-flex">
      <!-- Menú lateral -->
      <transition name="slide">
        <div v-if="menuAbierto || isDesktop" class="config-menu bg-white shadow-sm p-3">
          <h5 class="text-muted mb-3">⚙️ Configuración</h5>

          <template v-if="esAdmin">
            <p class="menu-section">Administración</p>
            <router-link to="/configuracion/usuarios" class="menu-item">
              <font-awesome-icon :icon="['fas', 'user-cog']" class="me-2" /> Usuarios
            </router-link>
            <router-link to="/configuracion/roles-permisos" class="menu-item">
              <font-awesome-icon :icon="['fas', 'users-cog']" class="me-2" /> Roles y Permisos
            </router-link>
            
            <router-link to="/configuracion/ubicaciones" class="menu-item">
              <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="me-2" /> Ubicaciones
            </router-link>
            <router-link to="/configuracion/suscripciones" class="menu-item">
              <font-awesome-icon :icon="['fas', 'file-invoice-dollar']" class="me-2" /> Suscripciones
            </router-link>
            <router-link to="/configuracion/solicitudes-servicio" class="menu-item">
              <font-awesome-icon :icon="['fas', 'handshake']" class="me-2" /> Solicitudes
            </router-link>
          </template>

          <p class="menu-section mt-4">Mi cuenta</p>
          <router-link to="/configuracion/gestion-usuarios-club" class="menu-item">
            <font-awesome-icon :icon="['fas', 'users']" class="me-2" /> Usuarios del Club
          </router-link>
          <router-link to="/configuracion/variables-tareas" class="menu-item">
              <font-awesome-icon :icon="['fas', 'sliders-h']" class="me-2" /> Variables
            </router-link>
          <router-link to="/configuracion/moneda" class="menu-item">
            <font-awesome-icon :icon="['fas', 'coins']" class="me-2" /> Moneda
          </router-link>
          <router-link to="/configuracion/renovar-suscripcion" class="menu-item">
            <font-awesome-icon :icon="['fas', 'credit-card']" class="me-2" /> Suscripción y Pagos
          </router-link>
          <router-link to="/configuracion/editar-perfil" class="menu-item">
            <font-awesome-icon :icon="['fas', 'user-edit']" class="me-2" /> Perfil
          </router-link>
        </div>
      </transition>

      <!-- Contenido -->
      <div class="config-content flex-fill p-3">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuAbierto: false,
      isDesktop: window.innerWidth >= 768
    };
  },
  computed: {
    esAdmin() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user?.permisos?.includes('per_admin');
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isDesktop = window.innerWidth >= 768;
      if (this.isDesktop) this.menuAbierto = true;
    }
  }
};
</script>

<style scoped>
.config-container {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.config-menu {
  width: 280px;
  min-width: 280px;
  border-right: 1px solid #dee2e6;
  z-index: 10;
  background-color: #fff;
}

.menu-section {
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 5px;
  padding-left: 5px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  color: #333;
  border-radius: 6px;
  text-decoration: none;
  margin-bottom: 6px;
  transition: all 0.2s ease-in-out;
}

.menu-item:hover {
  background-color: #e3f2fd;
  color: #0d6efd;
}

.menu-item.router-link-active {
  background-color: #0d6efd;
  color: #fff;
  font-weight: 500;
}

.config-content {
  flex-grow: 1;
  padding: 30px;
}

/* Slide animation */
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-enter-to {
  transform: translateX(0);
  opacity: 1;
}
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>
